module.exports = "/assets/data/9a1aa238e287f3622dc52edf5d65e03b-NN6.data.json";